module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_black-joker.aa4e7da6.svg";